import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
   position: relative;
   z-index: 2;
   display: flex;
   align-items: center;
   flex-direction: column;
`
const HeaderWrapper = styled.div`
   display: flex;
`


const HeaderSpan = styled.div`
  background: #CB1700;
  width: 25vw;
  height: 9.19vw;
`

const ContentSpan = styled.div`
  background: #CB1700;
  width: 15vw;
  //height: 500px;
`
const IconsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  background: #CB1700;
  width: 70vw;
  @media only screen and (max-width: 600px) {
      width: 100%;
      padding-bottom: 40px;
    }
   color: white;
  h2{
    font-size: 5rem;
    padding: 0;
    margin: 0;
  }
  
  h1{
  width: 100%;
  text-align: center;
    font-size: 2rem !important;
     color: white !important;
    padding: 2vw;
    //margin: 0;
  }
  
`

const IconWrapper = styled.div`
display: flex;
flex-direction: column;
font-size: 1.2em;
font-weight: bold;
text-align: center;
align-items: center;

width: 33%;
 @media only screen and (max-width: 1200px) {
      width: 50%;
    }
 @media only screen and (max-width: 600px) {
      width: 100%;
    }
color: white;
svg{
  width: 25%;
  padding-bottom: 20px;
}
p{
  padding: 0 20px;
  font-weight: normal;
  font-size: 1.2rem;
}
padding-bottom: 20px;
@media only screen and (max-width: 600px) {
  padding: 40px 0;
}

`

const PointBlock = ({number, children}) => {
    return (
        <IconWrapper>
            <h2>{number}</h2>
            <p>{children}</p>
        </IconWrapper>
    )
}

const WhyImportantBlock = ({}) => {
    return (
        <Wrapper>
            <HeaderWrapper>
                <ContentSpan/>
                <IconsWrapper>
                    <h1>ПОЧЕМУ ЭТО ВАЖНО?</h1>
                    <PointBlock number={1}>
                        Каждый день, который оттягивает неизбежное, ослабляет нашу страну, заставляет уезжать людей и компании.
                    </PointBlock>
                    <PointBlock number={2}>
                        Каждое действие людей, утративших понимание добра и зла, все больше склоняет народ к ненависти.
                    </PointBlock>
                    <PointBlock number={3}>
                        Каждый день происходит насилие над людьми, над человеческой личностью,
                        над умными и талантливыми людьми, а самые смелые сидять в тюрьмах.
                    </PointBlock>
                    <PointBlock number={4}>
                        Каждый день отдаляет нас от страны, где важен каждый человек и каждая инициатива.
                    </PointBlock>
                    <PointBlock number={5}>
                        Каждый день с Лукашенко у власти отдаляет нас от Беларуси, которую мы заслужили.
                    </PointBlock>
                </IconsWrapper>
                <ContentSpan/>
            </HeaderWrapper>

        </Wrapper>

    )
}

export default WhyImportantBlock;
